// ============================================
// CONFIGURAÇÃO DO APLICATIVO
// ============================================
// Este arquivo centraliza todas as configurações do aplicativo.
// Modifique os valores abaixo para personalizar sua instalação.

// Mapeamento de domínios para configurações específicas
const APP_DESCRIPTION_BASE = "Sistema de Tracking para %s. Acompanhe experiência, mortes e progresso dos seus personagens.";
const TENANT_CONFIGS = {
  'tibao.tibaorealm.com.br': {
    APP_NAME: 'Tibão',
    APP_DESCRIPTION: APP_DESCRIPTION_BASE.replace('%s', 'Tibia'),
    GAME_NAME: 'Tibia'
  },
  'chumbadores.tibaorealm.com.br': {
    APP_NAME: 'Chumbadores',
    APP_DESCRIPTION: APP_DESCRIPTION_BASE.replace('%s', 'Chumbadores'),
    GAME_NAME: 'Tibia'
  },
  // Adicione novos tenants aqui
  // 'novosite.ddns.net': {
  //   APP_NAME: 'Novo Site',
  //   APP_DESCRIPTION: 'Descrição do novo site...',
  //   GAME_NAME: 'Nome do Jogo'
  // }
};

// Detecta o tenant atual
const getCurrentTenant = () => {
  const hostname = window.location.hostname;
  const envTenant = process.env.REACT_APP_TENANT_DOMAIN;

  // Prioriza variável de ambiente, depois hostname
  const tenantDomain = envTenant || (hostname === 'localhost' ? 'chumbadores.tibaorealm.com.br' : hostname);

  return tenantDomain;
};

// Configurações específicas do tenant atual
const currentTenant = getCurrentTenant();
const tenantConfig = TENANT_CONFIGS[currentTenant] || TENANT_CONFIGS['chumbadores.tibaorealm.com.br']; // Fallback

// Configurações Gerais do Site
export const APP_CONFIG = {
  // Nome do aplicativo (dinâmico por tenant)
  APP_NAME: tenantConfig.APP_NAME,

  // Descrição do aplicativo (dinâmica por tenant)
  APP_DESCRIPTION: tenantConfig.APP_DESCRIPTION,

  // Nome do jogo/servidor (dinâmico por tenant)
  GAME_NAME: tenantConfig.GAME_NAME,

  // Domínio do tenant atual
  TENANT_DOMAIN: currentTenant,

  // Versão da aplicação web
  WEB_VERSION: '1.6.3',
  
  // Termos customizáveis
  TERMS: {
    CHARACTER: 'Personagem',
    CHARACTERS: 'Personagens',
    GUILD: 'Guild',
    WORLD: 'Mundo',
    LEVEL: 'Nível',
    EXPERIENCE: 'Experiência',
    DEATH: 'Morte',
    DEATHS: 'Mortes',
    VOCATION: 'Vocação'
  },
  
  // Configurações de exibição
  DISPLAY: {
    // Número padrão de linhas por página nas tabelas
    DEFAULT_ROWS_PER_PAGE: 10,
    
    // Opções de linhas por página
    ROWS_PER_PAGE_OPTIONS: [5, 10, 25, 50],
    
    // Ordenação padrão (campo e direção)
    DEFAULT_SORT: {
      field: 'level',
      direction: 'desc' // 'asc' ou 'desc'
    }
  },
  
  // Títulos dos cards de highscore na home
  HIGHSCORES: {
    YEAR_CHAMPION: {
      title: 'Campeão do Ano',
      description: 'Maior experiência do ano'
    },
    MONTH_HIGHLIGHT: {
      title: 'Destaque do Mês',
      description: 'Maior experiência do mês'
    },
    YEAR_LOSS: {
      title: 'Maior Perda Anual',
      description: 'Maior perda de experiência no ano'
    },
    MONTH_LOSS: {
      title: 'Maior Perda Mensal',
      description: 'Maior perda de experiência no mês'
    }
  }
};

// Configuração da API Backend
export const API_CONFIG = {
  BASE_URL: 'https://api.tibaorealm.com.br',
  ENDPOINTS: {
    PAYLOAD: '/api/payload',
    DEATHS: '/api/mortes',
    CHARACTERS: '/api/list',
    EXPERIENCE: '/api/exp',
    UPDATE_STATUS: '/api/update-status',
    ALIVE: '/alive',
    RARE_BOSSES: '/api/creatures/rare-bosses',
    BOSS_PREDICTIONS: '/api/creatures/boss-predictions'
  }
};

// Headers padrão para requisições (multi-tenant)
export const getAuthHeaders = () => ({
  'X-Tenant-Domain': APP_CONFIG.TENANT_DOMAIN,
  'Content-Type': 'application/json'
});

// Função helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  
  //const isDevelopment = process.env.NODE_ENV === 'development';
  //return isDevelopment ? endpoint : `${API_CONFIG.BASE_URL}${endpoint}`;
  
  return `${API_CONFIG.BASE_URL}${endpoint}`;
}; 